export const JsonHelpers = {
  extractStringField: (payload: Record<string, any>, field: string): string => {
    const value = payload[field];
    if (typeof value === 'string') {
      return value;
    }
    return '';
  },

  extractNumberField: (
    payload: Record<string, any>,
    field: string,
  ): number | null => {
    const value = payload[field];
    if (typeof value === 'number') {
      return value;
    }
    return null;
  },

  extractBooleanField: (
    payload: Record<string, any>,
    field: string,
  ): boolean | null => {
    const value = payload[field];
    if (typeof value === 'boolean') {
      return value;
    }
    return null;
  },
};
